import { render, staticRenderFns } from "./CustomerDrawer.vue?vue&type=template&id=57f2644b&"
import script from "./CustomerDrawer.vue?vue&type=script&lang=ts&"
export * from "./CustomerDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerDrawer.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports